// extracted by mini-css-extract-plugin
export default {"Button":"button_Button_KXhd1","PrimaryButton":"button_PrimaryButton_ixtLl","SecondaryButton":"button_SecondaryButton_zMAgR","DisabledButton":"button_DisabledButton_k2P2K"};